import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import api from "./api";
import "./assets/css/app.scss";

// 样式初始化
import "normalize.css/normalize.css";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI, {
  size: localStorage.getItem("size") || "medium",
});

// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
Vue.component('ImagePreview', ImagePreview)
import "./icons";

import HeadView from "@/components/HeadView";
Vue.component("HeadView", HeadView);

import PageIndicator from "@/components/PageIndicator";
Vue.component("PageIndicator", PageIndicator);

import SearchView from "@/components/SearchView";
Vue.component("SearchView", SearchView);

import ECharts from "vue-echarts";
// 手动引入 ECharts 各模块来减小打包体积
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
use([
  CanvasRenderer,
  BarChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
]);

Vue.component("v-chart", ECharts);

import JsonExcel from "vue-json-excel"; // 导出
Vue.component("downloadExcel", JsonExcel);

Vue.config.productionTip = false;
Vue.prototype.$api = api;
// Vue.config.devtools = true; //调试模式

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
